var React = require('react');

function IcNeutralComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-neutral"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M10.0003 18.0833C5.53602 18.0833 1.91699 14.4642 1.91699 9.99996C1.91699 5.53566 5.53602 1.91663 10.0003 1.91663C14.4646 1.91663 18.0837 5.53566 18.0837 9.99996C18.0837 14.4642 14.4646 18.0833 10.0003 18.0833ZM10.0003 16.9166C13.8203 16.9166 16.917 13.8199 16.917 9.99996C16.917 6.17999 13.8203 3.08329 10.0003 3.08329C6.18035 3.08329 3.08366 6.17999 3.08366 9.99996C3.08366 13.8199 6.18035 16.9166 10.0003 16.9166ZM13.0837 13.0833V11.9166H6.91699V13.0833H13.0837ZM6.66699 8.91663C6.11471 8.91663 5.66699 8.46889 5.66699 7.91663C5.66699 7.36434 6.11471 6.91663 6.66699 6.91663C7.21928 6.91663 7.66699 7.36434 7.66699 7.91663C7.66699 8.46889 7.21928 8.91663 6.66699 8.91663ZM13.3337 8.91663C12.7814 8.91663 12.3337 8.46889 12.3337 7.91663C12.3337 7.36434 12.7814 6.91663 13.3337 6.91663C13.8859 6.91663 14.3337 7.36434 14.3337 7.91663C14.3337 8.46889 13.8859 8.91663 13.3337 8.91663Z","fill":"#3E3E3E"})));
}

IcNeutralComponent.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = IcNeutralComponent;

IcNeutralComponent.default = IcNeutralComponent;



//////////////////
// WEBPACK FOOTER
// ./src/components/FeedbackModalV2/images/ic-neutral.component.svg
// module id = 703
// module chunks = 0